// # Filename: src/components/leaderboard/BestHandCard.jsx
import React from "react";
import Card from "../ui/Card";
import PokerCard from "../poker/PokerCard";

export default function BestHandCard({ bestHand }) {
  if (!bestHand) {
    return (
      <Card variant="glass" className="p-3 mb-3 sm:mb-4">
        <p className="text-xs text-text-faint">
          Your best hand shows up here after your first poker showdown.
        </p>
      </Card>
    );
  }

  return (
    <Card variant="glass" className="p-3 mb-3 sm:mb-4">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] tracking-[0.2em] text-text-muted uppercase">
            Your best hand
          </div>
          <div className="text-sm font-semibold text-brand-cyan truncate">
            {bestHand.label}
          </div>
        </div>
        <div className="flex gap-1 shrink-0">
          {bestHand.cards.map((card, idx) => (
            <PokerCard key={`${card}-${idx}`} card={card} small />
          ))}
        </div>
      </div>
    </Card>
  );
}
